import React from 'react'
import ThemeForm from './ThemeForm'

const Add = () => {
  return (
    <ThemeForm title={'Add'}/>
  )
}

export default Add
